<div class="maintenance-requests" *transloco="let t; prefix: 'maintenanceOverview'">
  <div class="filter-container pb-3">
    <div class="search-bulk-actions">
      <app-search
        [placeholder]="t('table.searchAsset')"
        [disabled]="isLoading"
        (searchTermUpdated)="onSearchTermUpdate($event)"
        [searchTerm]="searchTerm"
        [customWidth]="'300px'">
      </app-search>
      <button
        class="btn-bulk-approve"
        (click)="onBulkApproveClick()"
        [disabled]="selectedRows.size === 0">
        {{ t('table.bulkApprove') }}
      </button>
    </div>
  </div>

  <div class="table-container">
    <div class="table-inner">
      @if (isLoading) {
        <div class="loading-overlay">
          <span class="spinner-border"></span>
        </div>
      } @else if (hasError) {
        <div class="state-overlay">
          <app-error-state></app-error-state>
        </div>
      } @else if (!maintenanceRequests.length) {
        <div class="state-overlay">
          <app-empty-state></app-empty-state>
        </div>
      }

      <table
        class="maintenance-table"
        [class.is-loading]="isLoading"
        [class.is-full-page]="!isLoading && maintenanceRequests.length >= pageSize">
        <thead>
          <tr>
            <th class="checkbox-col">
              @if (!isAllSelected && !isIndeterminate) {
                <button type="button" class="selection-toggle-btn" (click)="onSelectAllClick($event)">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#DADADE" stroke-linejoin="round" />
                  </svg>
                </button>
              }
              @if (isIndeterminate) {
                <button type="button" class="selection-toggle-btn" [disabled]="isLoading" (click)="onSelectAllClick($event)">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#EE2737" />
                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#EE2737" />
                    <line x1="4.5" y1="8" x2="11.5" y2="8" stroke="white" stroke-width="2" stroke-linecap="round" />
                  </svg>
                </button>
              }
              @if (isAllSelected) {
                <button type="button" class="selection-toggle-btn" [disabled]="isLoading" (click)="onSelectAllClick($event)">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#EE2737" />
                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#EE2737" />
                    <path d="M2.95312 8.85384L6.28646 11.9788L12.9531 3.64551" stroke="white" stroke-width="2" stroke-linejoin="round" />
                  </svg>
                </button>
              }
            </th>
            <th class="asset">{{ t('table.asset') }}</th>
            <th class="maint-model">{{ t('table.maintModel') }}</th>
            <th class="source">{{ t('table.source') }}</th>
            <th class="range-left">{{ t('table.rangeLeft') }}</th>
            <th class="service-type">{{ t('table.serviceType') }}</th>
            <th class="estimated-cost">{{ t('table.estimatedCost') }}</th>
            <th class="actions">{{ t('table.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          @if (isLoading) {
            <tr class="loading-row">
              <td colspan="8"></td>
            </tr>
          } @else if (maintenanceRequests.length) {
            @for (row of maintenanceRequests; track row.id) {
              <tr>
                <td class="checkbox-col">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [checked]="isRowSelected(row.id)"
                    [disabled]="row.maintenanceStatus === maintenanceStatus.Rejected"
                    (change)="onRowSelectChange(row.id, $event)" />
                </td>
                <td class="asset">
                  <span class="asset-name" [title]="row.assetName">{{ row.assetName }}</span>
                </td>
                <td class="maint-model">{{ getMaintenanceModel(row.maintenanceModel) }}</td>
                <td class="source">
                  <div class="two-line-cell">
                    <span>{{ getMaintenanceSource(row.maintenanceSource) }}</span>
                    <span class="sub-text">{{ formatDate(row.createdAt) }}</span>
                  </div>
                </td>
                <td class="range-left">{{ formatRangeLeft(row.rangeLeft) }}</td>
                <td class="service-type">
                  <div class="two-line-cell">
                    <span [title]="row.localizedMaintenanceReason || row.maintenanceReason">{{ row.localizedMaintenanceReason || row.maintenanceReason }}</span>
                    <span class="sub-text" [title]="formatMaintenanceType(row.isAutoTrigger, row.maintenanceType)">{{ formatMaintenanceType(row.isAutoTrigger, row.maintenanceType) }}</span>
                  </div>
                </td>
                <td class="estimated-cost">{{ formatCurrency(row.cost) }}</td>
                <td class="actions">
                  @if (row.maintenanceStatus === maintenanceStatus.Pending) {
                    <div class="action-buttons">
                      <button class="btn-reject" (click)="onRejectClick(row)" [title]="t('table.reject')">
                        <i class="ph ph-x"></i>
                      </button>
                      <button class="btn-approve" (click)="onApproveClick(row)" [title]="t('table.approve')">
                        <i class="ph ph-check"></i>
                        {{ t('table.approve') }}
                      </button>
                    </div>
                  }
                  @if (row.maintenanceStatus === maintenanceStatus.Rejected) {
                    <div class="action-buttons">
                      <button class="btn-rejected" (click)="onRejectedClick(row)">
                        <i class="ph ph-pencil-simple"></i>
                        {{ t('table.rejected') }}
                      </button>
                    </div>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="table-footer">
      <p class="pagination-text">{{ 'common.showingOutOf' | transloco: { current: showingCount, total: totalCount } }}</p>

      <app-pagination [totalPages]="totalPages" [currentPage]="currentPage" (pageChange)="onPageChange($event)"></app-pagination>

      <button class="export-btn" [class.invisible]="true" (click)="onExportClick()" [disabled]="isLoading">
        <span>{{ t('table.export') }}</span>
        <img src="./assets/images-fuel/downloadIcon.svg" [attr.alt]="'common.export' | transloco" />
      </button>
    </div>
  </div>
</div>